// import dayjs from 'dayjs'
import {
  Box,
  Button,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { ArrowForward, Cancel } from '@mui/icons-material'
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { AlertSetting, AlertType } from 'src/v3/core/types'

let ALERT_SETTING_OPTIONS: { value: AlertSetting; label: string }[] = [
  { value: 'Disabled', label: 'Disabled' },
  { value: 'User', label: 'User' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Both', label: 'Both' },
]

let ALERT_TYPE_OPTIONS: { value: AlertType; label: string }[] = [
  { value: 'Email', label: 'Email' },
  { value: 'Studio', label: 'Studio' },
  { value: 'Both', label: 'Both' },
]

type Props = {
  form: any
  onCancel: () => void
  onContinue: () => void
  canContinue: boolean
}

export default function ComplianceDetailsStep({
  form,
  onCancel,
  onContinue,
  canContinue,
}: Props) {
  return (
    <>
      <Card className="p-6">
        <Typography variant="h6" className="mb-4">
          Requirement Details
        </Typography>

        <Box className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <form.Field name="name">
            {(field: any) => (
              <TextField
                label="Name"
                placeholder="Requirement Name"
                fullWidth
                className="lg:col-span-2"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                onBlur={field.handleBlur}
                error={
                  field.state.meta.isTouched &&
                  field.state.meta.errors.length > 0
                }
                helperText={
                  field.state.meta.isTouched
                    ? field.state.meta.errors[0]
                    : undefined
                }
                sx={{ bgcolor: 'background.paper' }}
              />
            )}
          </form.Field>

          {/* Spacer kept Name alone on its row beside the date pickers.
          <Box />
          */}

          {/* Issue/expiration dates are hidden while requirement dates are phased out.
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <form.Field name="issueDate">
              {(field: any) => (
                <DatePicker
                  label="Issue Date"
                  value={field.state.value ? dayjs(field.state.value) : null}
                  onChange={(val) =>
                    field.handleChange(val ? val.toISOString() : '')
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      onBlur: field.handleBlur,
                      error:
                        field.state.meta.isTouched &&
                        field.state.meta.errors.length > 0,
                      helperText: field.state.meta.isTouched
                        ? field.state.meta.errors[0]
                        : undefined,
                      sx: { bgcolor: 'background.paper' },
                    },
                  }}
                />
              )}
            </form.Field>

            <form.Field name="expirationDate">
              {(field: any) => (
                <DatePicker
                  label="Expiration Date"
                  value={field.state.value ? dayjs(field.state.value) : null}
                  onChange={(val) =>
                    field.handleChange(val ? val.toISOString() : '')
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      onBlur: field.handleBlur,
                      error:
                        field.state.meta.isTouched &&
                        field.state.meta.errors.length > 0,
                      helperText: field.state.meta.isTouched
                        ? field.state.meta.errors[0]
                        : undefined,
                      sx: { bgcolor: 'background.paper' },
                    },
                  }}
                />
              )}
            </form.Field>
          </LocalizationProvider>
          */}

          <form.Field name="alertSetting">
            {(field: any) => (
              <FormControl fullWidth sx={{ bgcolor: 'background.paper' }}>
                <InputLabel id="alert-setting-label">Alert Setting</InputLabel>
                <Select
                  labelId="alert-setting-label"
                  label="Alert Setting"
                  value={field.state.value}
                  onChange={(e) =>
                    field.handleChange(e.target.value as AlertSetting)
                  }
                  onBlur={field.handleBlur}
                >
                  {ALERT_SETTING_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </form.Field>

          <form.Field name="alertType">
            {(field: any) => (
              <FormControl fullWidth sx={{ bgcolor: 'background.paper' }}>
                <InputLabel id="alert-type-label">Alert Type</InputLabel>
                <Select
                  labelId="alert-type-label"
                  label="Alert Type"
                  value={field.state.value}
                  onChange={(e) =>
                    field.handleChange(e.target.value as AlertType)
                  }
                  onBlur={field.handleBlur}
                >
                  {ALERT_TYPE_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </form.Field>
        </Box>
      </Card>

      <Box className="flex justify-end gap-3 mt-6">
        <Button variant="outlined" startIcon={<Cancel />} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          endIcon={<ArrowForward />}
          onClick={onContinue}
          disabled={!canContinue}
        >
          Continue to Requirements
        </Button>
      </Box>
    </>
  )
}
